var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoneyOff = function SvgMoneyOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9171 12.65C26.1804 12.65 27.3904 14.2083 27.5004 16.5H31.5521C31.4237 13.3467 29.4987 10.45 25.6671 9.515V5.5H20.1671V9.46C19.4521 9.60667 18.7921 9.845 18.1504 10.12L20.9187 12.8883C21.5054 12.7417 22.1837 12.65 22.9171 12.65Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0284 7.1875L7.44336 9.7725L13.75 16.0792C13.75 19.8925 16.61 21.9825 20.9184 23.2475L27.3534 29.6825C26.73 30.5808 25.4284 31.3508 22.9167 31.3508C19.14 31.3508 17.655 29.6642 17.4534 27.5008H13.42C13.64 31.5158 16.6467 33.7708 20.1667 34.5225V38.5008H25.6667V34.5592C27.4267 34.2292 29.0217 33.5508 30.1767 32.5058L34.2467 36.5758L36.8317 33.9908L10.0284 7.1875Z",
    fill: "#222222"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoneyOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money_off.1805d0a3.svg";
export { ForwardRef as ReactComponent };